<template>
  <b-modal ref="modalAdd" title="Send to script" centered v-on:ok="addToScript">
    <div>
      <label class="width-full"
        ><b>Select storyboard:</b>
        <select
          class="form-control m-b-10"
          v-model="selectedStoryboard"
          @change="filterStages"
        >
          <option selected disabled value="0">Select storyboard</option>
          <option
            v-for="storyboard in filterStoryboards"
            :key="storyboard.id"
            :value="storyboard.id"
          >
            {{ storyboard.name }}
          </option>
        </select>
      </label>
    </div>
    <div>
      <label class="width-full"
        ><b>Select stage:</b>
        <select
          class="form-control m-b-10"
          v-model="selectedStage"
          @change="filterSteps"
        >
          <option selected disabled value="0">Select stage</option>
          <option
            v-for="stage in filteredStages"
            :key="stage.id"
            :value="stage.id"
          >
            {{ stage.name }}
          </option>
        </select>
      </label>
    </div>
    <div>
      <label class="width-full"
        ><b>Select step:</b>
        <select
          class="form-control m-b-10"
          v-model="selectedStep"
          @change="buttonState"
        >
          <option selected disabled value="0">Select step</option>
          <option v-for="step in filteredSteps" :key="step.id" :value="step.id">
            {{ step.name }}
          </option>
        </select>
      </label>
    </div>
    <div v-if="selectedStep != 0" class="alert alert-secondary m-b-0">
      <h5><i class="fa fa-info-circle"></i>Add</h5>
      <div v-if="itemsToAdd">
        <p>Are you sure you want to send these items?</p>
        <ul>
          <li v-for="item in itemsToAdd" :key="item.id">{{ item.name }}</li>
        </ul>
      </div>
      <div v-else>
        <p>Are you sure you want to send {{ itemToAdd.name }}?</p>
      </div>
    </div>
    <template v-slot:modal-footer="{ ok, hide, cancel }">
      <b-button variant="white" @click="cancel()"> Cancel </b-button>
      <b-button variant="yellow" :disabled="disabled" @click="ok()">
        Send
      </b-button>
      <b-button
        variant="inverse"
        :disabled="disabled"
        @click="hide(addAndGo())"
      >
        Send and go to script
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AddToScriptModal',
  props: ['itemToAdd', 'itemsToAdd'],
  data() {
    return {
      selectedStoryboard: 0,
      selectedStage: 0,
      selectedStep: 0,
      filteredStages: [],
      filteredSteps: [],
      disabled: true
    }
  },
  computed: {
    ...mapState('event', ['activeEvent']),
    ...mapState('step', ['steps']),
    ...mapState('stage', ['stages']),
    ...mapState('storyboard', ['storyboards']),
    filterStoryboards() {
      if (this.selectedStoryboard == 0) {
        this.filterStages()
      }
      return this.storyboards
    }
  },
  methods: {
    ...mapActions('step', ['getSteps', 'updateStep']),
    ...mapActions('stage', ['getStages']),
    ...mapActions('storyboard', ['getStoryboards']),
    filterStages() {
      this.selectedStage = 0
      this.filteredStages = []
      this.stages.forEach((stage) => {
        if (stage.storyboard == this.selectedStoryboard) {
          this.filteredStages.push(stage)
        }
      })
      this.filterSteps()
    },
    filterSteps() {
      this.selectedStep = 0
      this.buttonState()
      this.filteredSteps = []
      this.steps.forEach((step) => {
        if (step.stage == this.selectedStage) {
          this.filteredSteps.push(step)
        }
      })
    },
    buttonState() {
      if (this.selectedStep == 0) {
        this.disabled = true
      } else {
        this.disabled = false
      }
    },
    addToScript() {
      if (this.selectedStep != 0) {
        let ids = []
        const selectedStep = this.steps.find(
          (s) => parseInt(s.id) === parseInt(this.selectedStep)
        )
        ids = [...ids, ...selectedStep.workitems.map((i) => i.id)]

        if (this.itemsToAdd) {
          const itemIdsToAdd = this.itemsToAdd.map((i) => i.id)
          ids = [...ids, ...itemIdsToAdd]
        }
        if (this.itemToAdd) {
          ids.push(this.itemToAdd.id)
        }
        let stepData = JSON.stringify({
          workitemIds: [...new Set(ids)]
        })
        let stepId = this.selectedStep
        this.updateStep({ stepId, stepData })
      }
    },
    addAndGo() {
      if (this.selectedStep != 0) {
        this.addToScript()
        this.$router.push(
          '/script/' + this.$route.params.type + '/' + this.selectedStep
        )
      }
    }
  },
  mounted() {
    this.getSteps(this.activeEvent.id)
    this.getStages(this.activeEvent.id)
    this.getStoryboards(this.activeEvent.id)
  }
}
</script>
